<div class="page-wrapper">
  @if (chatState.chatReady()) {
    <mat-card class="messaging-card" appearance="outlined">
      <mat-card-header class="messaging-header">
        <mat-card-subtitle>
          {{ chatState.recipient()?.name }} -
          <span class="phone-header">{{
            formatForDisplay(chatState.recipient()?.phoneNumber || '')
          }}</span>
        </mat-card-subtitle>
        @if (chatState.hasUnreadMessages()) {
          <button
            mat-icon-button
            aria-label="Mark chat as read"
            matTooltip="Mark as Read"
            (click)="handleMarkAsRead()"
          >
            <mat-icon fontSet="material-icons-outlined">mark_chat_unread</mat-icon>
          </button>
        } @else {
          <mat-icon fontSet="material-icons-outlined" class="marked-as-read"
            >mark_chat_read</mat-icon
          >
        }
      </mat-card-header>
      <mat-divider />
      <mat-card-content class="messaging-content">
        <div *ngIf="loadingHistory" class="loading-history">
          <mat-progress-spinner mode="indeterminate" diameter="40" class="loading-spinner">
          </mat-progress-spinner>
          <div class="loading-text">Loading messages...</div>
        </div>

        <app-message-history
          class="message-history"
          *ngIf="!loadingHistory"
          [messages]="messages"
          [statuses]="statuses"
        >
        </app-message-history>
      </mat-card-content>
      <div *ngIf="chatState.isOptedOut(); else actionBar">
        <mat-card-footer class="messaging-footer"></mat-card-footer>
        <mat-card-actions class="messaging-actions">
          <div class="opted-out-container">Opted out - Do not message</div>
        </mat-card-actions>
      </div>
      <ng-template #actionBar>
        <mat-card-footer class="messaging-footer">
          <div class="chat-input-container">
            <app-media-preview
              *ngIf="uploadedMedia.length"
              [media]="uploadedMedia"
              size="small"
              [showFilename]="true"
              [showFilesize]="true"
              [showCloseButton]="true"
              (remove)="removeAttachment($event)"
            ></app-media-preview>
            <textarea
              [(ngModel)]="newMessageText"
              [maxLength]="chatState.maxMessageLength()"
              placeholder="Type a message..."
              class="chat-textarea"
              appAutoResize
            ></textarea>
            <div class="char-limit-warning">
              @if (newMessageText.length >= chatState.maxMessageLength()) {
                {{ chatState.maxMessageLengthError() }}
              }
            </div>
          </div>
        </mat-card-footer>
        <mat-card-actions class="messaging-actions">
          <div class="icons-container">
            <button
              mat-icon-button
              aria-label="Add emoji"
              (click)="showEmojiPicker = !showEmojiPicker"
              type="button"
            >
              <mat-icon>mood</mat-icon>
            </button>
            <button
              mat-icon-button
              (click)="fileInput.click()"
              [disabled]="uploading"
              #fileInputButton
            >
              <mat-icon class="forty-five-clockwise">attach_file</mat-icon>
            </button>
            <input #fileInput type="file" (change)="onFileSelected($event)" multiple hidden />
          </div>
          <div *ngIf="uploading" class="uploading-spinner">
            <div class="spinner-message">Please wait...</div>
            <mat-progress-spinner mode="indeterminate" diameter="24" class="upload-spinner">
            </mat-progress-spinner>
          </div>
          <div *ngIf="uploadError" class="upload-error">
            <span>The following files are not supported:</span>
            <p class="error-message">{{ uploadError }}</p>
            <span class="information">The following types are supported:</span>
            <p class="supported-media">{{ supportedMediaList }}</p>
          </div>
          <div class="emoji-picker-container" *ngIf="showEmojiPicker">
            <emoji-mart title="Add emoji" (emojiClick)="addEmoji($event)"></emoji-mart>
          </div>
          <div class="button-container">
            <button
              mat-raised-button
              color="styled-button--primary"
              (click)="handleSendMessage()"
              [disabled]="!newMessageText.length && !uploadedMedia.length"
            >
              Send
            </button>
          </div>
        </mat-card-actions>
      </ng-template>
    </mat-card>
  } @else {
    <mat-card class="messaging-card" appearance="outlined">
      <mat-card-header class="messaging-header">
        <h3>New Conversation</h3>
      </mat-card-header>
      <mat-divider />
      <form [formGroup]="chatSetupForm" (ngSubmit)="handleChatSetup()">
        <mat-card-content class="messaging-setup">
          <mat-form-field appearance="outline" class="full-width-field">
            <mat-label>Sender Name</mat-label>
            <input matInput formControlName="senderName" required />
          </mat-form-field>
          <mat-form-field appearance="outline" class="full-width-field">
            <mat-label>Recipient Name</mat-label>
            <input matInput formControlName="recipientName" required />
          </mat-form-field>
          <mat-form-field appearance="outline" class="full-width-field">
            <mat-label>Recipient Phone</mat-label>
            <input
              matInput
              formControlName="recipientPhone"
              (input)="formatPhoneNumber('recipientPhone')"
              maxlength="14"
              required
            />
            <mat-error *ngIf="chatSetupForm.controls['recipientPhone'].invalid">
              Please enter a valid 10-digit phone number.
            </mat-error>
          </mat-form-field>
        </mat-card-content>
        <mat-card-actions class="messaging-actions">
          <button
            mat-raised-button
            color="styled-button--primary"
            type="submit"
            [disabled]="chatSetupForm.invalid"
          >
            Start Chat
          </button>
        </mat-card-actions>
      </form>
    </mat-card>
  }
</div>
